import { parseISO } from 'date-fns'
import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { initialFormValues } from './form/initialFormValues'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { Button } from '@components/shared/Button'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'
import { DatePicker } from '@components/shared/DatePicker'
import { useOcNfModal } from '@pages/OcNfModal/context'
import { useUser } from '@hooks/useUser'

import type { OcNfPurchaseOrdersFiltersProps } from './types'
import type { OcNfPurchaseOrdersFiltersFormProps } from './form/types'

import * as S from './styles'

export const OcNfPurchaseOrdersFilters = ({ onFilter }: OcNfPurchaseOrdersFiltersProps) => {
  const { filiData } = useUser()
  const { purchaseOrdersData, isPurchaseOrdersLoading } = useOcNfModal()

  const methods = useForm<OcNfPurchaseOrdersFiltersFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<OcNfPurchaseOrdersFiltersFormProps>) => console.log({ errors })

  const onSubmit = (formData: OcNfPurchaseOrdersFiltersFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <RowBox columns={4} marginTop={16} marginBottom={24}>
        <Select
          name="purchaseOrder"
          label="Ordem de Compra (OC)"
          options={
            purchaseOrdersData?.availableFilters?.purchaseOrderNumber?.map((purchaseOrder) => ({
              label: purchaseOrder,
              value: purchaseOrder
            })) || []
          }
          disabled={isPurchaseOrdersLoading}
        />
        <DatePicker
          name="expectedDate"
          label="Data Prevista"
          placeholder="DD/MM/AAAA"
          minDate={filiData?.startPeriod ? parseISO(filiData.startPeriod) : undefined}
          maxDate={filiData?.endPeriod ? parseISO(filiData.endPeriod) : undefined}
          disabled={isPurchaseOrdersLoading}
        />
        <Select
          name="status"
          label="Status"
          options={
            purchaseOrdersData?.availableFilters?.purchaseOrderStatus?.map((status) => ({
              label: status.name,
              value: status.name === 'Todos' ? 'Todos' : status.value
            })) || []
          }
          disabled={isPurchaseOrdersLoading}
        />

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isPurchaseOrdersLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isPurchaseOrdersLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </RowBox>
    </FormProvider>
  )
}
